// Português long names — actual UTF-8 (no \u00XX escapes).
export const MONTHS_LONG = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const MONTHS_SHORT = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]

// Trimestres (used by the month-grid quick-action chips T1..T4 in Phase 7).
export const TRIMESTRES = {
  T1: [0, 1, 2],
  T2: [3, 4, 5],
  T3: [6, 7, 8],
  T4: [9, 10, 11],
}

export const monthIndexFromName = (name) => {
  if (!name) return -1
  const idx = MONTHS_LONG.indexOf(name)
  if (idx >= 0) return idx
  return MONTHS_SHORT.indexOf(name)
}

export const monthNameFromIndex = (idx) => {
  if (typeof idx !== 'number' || idx < 0 || idx > 11) return ''
  return MONTHS_LONG[idx]
}

export const monthShortFromIndex = (idx) => {
  if (typeof idx !== 'number' || idx < 0 || idx > 11) return ''
  return MONTHS_SHORT[idx]
}
